var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/* 販売店情報設定（一覧） */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { store_search_params_init } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import { parse } from 'querystring';
import { jumpUrl } from '../../Common';
import StoreSearchForm from '../../organisms/StoreSearchForm';
import StoreList from '../../organisms/StoreList';
import LoadingModal from '../../organisms/LoadingModal';
import { useToggle } from '../../hooks/ToggleHooks';
import Moment from 'moment';
import { Modal, Button } from 'react-bootstrap';
import ModalTemplate from '../../molecules/ModalTemplate';
import ModalConfirm from '../../molecules/ModalConfirm';
import { useTranslation } from 'react-i18next';
import { number_of_search_init, select_brand_init, store_factor_search_params_init, } from '../../Const';
var Store = function () {
    var _a = useState(store_search_params_init), search_params = _a[0], setSearchParams = _a[1]; // 検索パラメータ
    var _b = useState(store_search_params_init), last_search_params = _b[0], setLastSearchParams = _b[1];
    var _c = useToggle(false), is_loading = _c[0], setIsLoading = _c[1];
    var _d = useState([]), stores = _d[0], setStores = _d[1];
    var _e = useState(number_of_search_init), history = _e[0], setHistory = _e[1]; //検索結果の件数
    var _f = useState(true), disabled = _f[0], setDisabled = _f[1]; //チェックボックスの状態管理
    var _g = useState({}), row_selection = _g[0], setRowSelection = _g[1]; // 行選択の状態管理
    var _h = useToggle(false), modal_output_exception = _h[0], toggleModalOutputException = _h[1];
    var _j = useState(''), modal_output_exception_body = _j[0], setModalOutputExceptionBody = _j[1];
    //削除ボタン用モーダル
    var _k = useToggle(false), is_delete = _k[0], toggleIsDelete = _k[1];
    var _l = useToggle(false), show_delete = _l[0], toggleShowDelete = _l[1];
    var _m = useToggle(false), show_completed = _m[0], toggleShowCompleted = _m[1];
    // 言語
    var _o = useTranslation(), t = _o.t, i18n = _o.i18n;
    var _p = useToggle(false), modal_error_show = _p[0], toggleModalErrorShow = _p[1]; //エラーモーダル管理
    var _q = useState(''), modal_error_message = _q[0], setModalErrorMessage = _q[1]; //例外メッセージ
    //検索項目
    var _r = useState(select_brand_init), select_bland = _r[0], setSelectBland = _r[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getStoreList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading();
                        return [4 /*yield*/, axios.get('staff/store/list/init')];
                    case 1:
                        response = _a.sent();
                        setStores(response.data.projects);
                        setHistory(response.data.history);
                        setSelectBland(response.data.option);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 案件を検索する
        var searchStores = function (store_search_param) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading();
                        return [4 /*yield*/, axios.get('staff/store/list/search', { params: store_search_param })];
                    case 1:
                        response = _a.sent();
                        setStores(response.data.projects);
                        setHistory(response.data.history);
                        setLastSearchParams(store_search_param);
                        //ショップ因子のラジオボタンのチェック状態に応じてチェックボックスの活性非活性を制御する。
                        setDisabled(store_search_param.shop_factor === store_factor_search_params_init.factor_all_selected);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        jumpUrl(error_2.response.data.url);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 検索パラメータの初期値を設定
        var new_params = Object.assign({}, search_params);
        if (location.search.length > 0) {
            // getパラメータをパースする
            var get_queries = parse(location.search.slice(1));
            //カンマ区切りのパラメータを配列に変換する。
            if (typeof get_queries.factor === 'string' && get_queries.factor.length > 0) {
                get_queries.factor = get_queries.factor.split(',');
            }
            // 検索パラメータの初期化状態にマージする
            Object.assign(new_params, get_queries);
            // パラメータを更新する
            setSearchParams(new_params);
        }
        // Ajaxリクエスト
        if (location.search.length > 0) {
            searchStores(new_params);
        }
        else {
            getStoreList();
        }
    }, []);
    /**
     * 検索処理
     * @returns void
     */
    var handleClickSearch = useCallback(function () {
        // クリックイベント
        var searchProjects = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading();
                        return [4 /*yield*/, axios.get('staff/store/list/search', { params: search_params })];
                    case 1:
                        response = _a.sent();
                        setStores(response.data.projects);
                        setHistory(response.data.history);
                        setLastSearchParams(search_params);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        console.error(error_3);
                        jumpUrl(error_3.response.data.url);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        searchProjects();
    }, [search_params]);
    /**
     * 削除処理
     * @returns void
     */
    var handleClickDelete = useCallback(function () {
        // チェックボックスの情報を収集する
        if (!checkRowSelection()) {
            return false;
        }
        //選択された案件を削除する。
        toggleShowDelete();
    }, [row_selection]);
    /**
     * マスタ情報の削除
     * @return void
     */
    var destroy = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var delete_store_list_1, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading();
                    toggleShowDelete();
                    delete_store_list_1 = { store_code: new Array() };
                    Object.keys(row_selection).map(function (key) {
                        if (row_selection[key]) {
                            delete_store_list_1.store_code.push(key);
                        }
                    });
                    return [4 /*yield*/, axios.delete('staff/store/deletes', { params: delete_store_list_1 })];
                case 1:
                    _a.sent();
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    console.log(error_4);
                    //TODO degawa モーダルに表示するメッセージは確認取れ次第修正するまで仮メッセージを表示
                    setModalErrorMessage('店舗情報の削除に失敗しました。');
                    toggleModalErrorShow();
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    /**
     * 検索パラメータ変更
     * @param e React.FormEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> イベントオブジェクト
     * @returns void
     */
    var handleChangeSearchParams = function (e) {
        var _a = e.currentTarget, id = _a.id, name = _a.name, value = _a.value;
        if (e.currentTarget.type === 'checkbox') {
            // チェックボックス
            var factor_1 = search_params.factor.includes(e.currentTarget.value)
                ? search_params.factor.filter(function (val) { return val !== e.currentTarget.value; })
                : __spreadArray(__spreadArray([], search_params.factor), [e.currentTarget.value]);
            setSearchParams(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[name] = factor_1, _a));
            });
        }
        else {
            setSearchParams(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[id] = value, _a));
            });
        }
    };
    /**
     * ラジオボタンのイベントハンドラ
     * @param e React.FormEvent<HTMLInputElement> イベントオブジェクト
     * @returns void
     */
    var handleClickRadioButton = function (e) {
        var _a = e.currentTarget, name = _a.name, value = _a.value;
        //ショップ因子のラジオボタンのチェック状態に応じて検索パラメータを更新する。
        var factor_all_selected = value === store_factor_search_params_init.factor_all_selected;
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = value, _a.factor_all_selected_flg = factor_all_selected, _a));
        });
        setDisabled(factor_all_selected);
    };
    /**
     * 検索パラメータ変更（日付型）
     * @param name string 検索パラメータ
     * @param value Date | null 変更する値
     * @returns void
     */
    var handleChangeSearchParamsDate = function (name, value) {
        var _a;
        setSearchParams(__assign(__assign({}, search_params), (_a = {}, _a[name] = value !== null ? Moment(value).format('YYYY-MM-DD') : '', _a)));
    };
    /**
     * 検索条件をクリア
     * @returns void
     */
    var handleClickClear = function () {
        setSearchParams(store_search_params_init);
    };
    /**
     * チェックボックスの選択状態をチェックする
     * @return boolean
     */
    var checkRowSelection = function () {
        var keys = Object.keys(row_selection);
        if (keys.length === 0) {
            // stateに行の選択状態が一切記録されてない場合
            toggleModalOutputException();
            //TODO degawa モーダルに表示するメッセージは確認取れ次第修正するまで仮メッセージを表示
            setModalOutputExceptionBody('1つ以上店舗を選択してください。');
            return false;
        }
        // row_selectionの状態を収集する
        var selection = keys.map(function (key) { return row_selection[key]; });
        if (!selection.includes(true)) {
            // checkedが0個の場合
            toggleModalOutputException();
            //TODO degawa モーダルに表示するメッセージは確認取れ次第修正するまで仮メッセージを表示
            setModalOutputExceptionBody('1つ以上店舗を選択してください。');
            return false;
        }
        return true;
    };
    /**
     * チェックボックスのcheckedを操作する
     * @param index 案件ID
     */
    var rowSelection = useCallback(function (index) {
        var new_row_selection = row_selection;
        var keys = Object.keys(row_selection);
        if (keys.length === 0) {
            new_row_selection[index] = true;
        }
        else {
            if (keys.includes(index)) {
                new_row_selection[index] = !new_row_selection[index];
            }
            else {
                new_row_selection[index] = true;
            }
        }
        setRowSelection(new_row_selection);
    }, [row_selection]);
    /**
     * 案件一覧画面に遷移
     * @returns void
     */
    var navigationToStoreCreate = useCallback(function () {
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/create";
    }, []);
    /**
     * 削除完了モーダルを非表示にして店舗一覧を更新する。
     * @returns void
     */
    var deletionCompleted = function () {
        toggleShowCompleted();
        handleClickSearch();
    };
    /**
     * 販売店一覧のハイパーリンクをクリックで店舗マスター（編集画面）に遷移する。
     * @param event イベントハンドラ
     * @returns void
     */
    var handleClickStoreAnchor = useCallback(function (event) {
        event.preventDefault();
        location.href = "" + event.currentTarget.href + makeQueryParameters();
    }, [last_search_params]);
    /**
     * 検索パラメータからクエリパラメータを作成する。
     *
     * @returns string クエリパラメータ
     */
    var makeQueryParameters = function () {
        return ("?target_bland=" + last_search_params.target_bland +
            ("&store_code=" + last_search_params.store_code) +
            ("&shop_factor=" + last_search_params.shop_factor) +
            ("&factor_all_selected_flg=" + last_search_params.factor_all_selected_flg) +
            ("&factor=" + last_search_params.factor) +
            ("&name_kanji=" + last_search_params.name_kanji) +
            ("&phone_number=" + last_search_params.phone_number) +
            ("&address=" + last_search_params.address) +
            ("&from_update_at=" + last_search_params.from_update_at) +
            ("&to_update_at=" + last_search_params.to_update_at) +
            ("&update_user_code=" + last_search_params.update_user_code));
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement(StoreSearchForm, { disabled: disabled, history: history, search_params: search_params, select_brand: select_bland, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleChangeSearchParamsDate: handleChangeSearchParamsDate, handleClickClear: handleClickClear, handleClickStoreCreate: navigationToStoreCreate, handleClickDelete: handleClickDelete, handleClickRadioButton: handleClickRadioButton }),
            React.createElement(StoreList, { stores: stores, handleRowChange: rowSelection, handleClickStoreAnchor: handleClickStoreAnchor })),
        React.createElement(LoadingModal, { show: is_loading }),
        React.createElement(Modal, { show: modal_output_exception, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_output_exception_body),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: toggleModalOutputException }, "OK"))),
        React.createElement(ModalTemplate, { show: show_delete, ClickCallBackNo: toggleShowDelete, ClickCallBackYes: destroy, title: '確認', body: '削除します。よろしいですか？', t: t }),
        React.createElement(ModalConfirm, { show: show_completed, title: '完了', body: '削除が完了しました。', clickCallBackConfirm: deletionCompleted }),
        React.createElement(Modal, { show: modal_error_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_error_message),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: toggleModalErrorShow }, "OK")))));
};
if (document.getElementById('store-list')) {
    render(React.createElement(Store, null), document.getElementById('store-list'));
}
